import { Keyword, Length, LengthOrPosition, NullLength, pickFirst } from '../../values/index.js';
export var Fit;
(function (Fit) {
    Fit["cover"] = "cover";
    Fit["contain"] = "contain";
    Fit["fill"] = "fill";
    Fit["none"] = "none";
})(Fit || (Fit = {}));
export const Props = (props = {}) => ({
    width: [NullLength(props.width), Length(props.width)].reduce(pickFirst),
    height: [NullLength(props.height), Length(props.height)].reduce(pickFirst),
    objectFit: Keyword(props.objectFit, Fit),
    objectPositionX: LengthOrPosition(props.objectPositionX),
    objectPositionY: LengthOrPosition(props.objectPositionY)
});
export const validate = () => true;
export const fix = (props, styles) => props;
export const label = 'Media sizing';
export const type = 'media';
export const property = 'mediaIds';
export const category = 'aspect';
export const summarize = (props, styles, formId) => props.objectFit;
//# sourceMappingURL=media.js.map